<div class="clinng-modal-error">
  <mat-spinner [diameter]="43"></mat-spinner>

  <h3 class="clinng-modal-error__title">Cargando</h3>

  <p class="clinng-modal-error__detail">
      Estamos realizando la búsqueda.
      <br />
      Gracias por tu espera.
  </p>
  <img src="./assets/svg/clinning.svg" alt="modal-loading" class="clinng-modal-error__image">
</div>
